import React from 'react';
import { Home, Search, TrendingUp, MapPin } from 'lucide-react';
import { whoIsItFor } from '../data/mockData';

const iconMap = {
  Home: Home,
  Search: Search,
  TrendingUp: TrendingUp,
  MapPin: MapPin
};

const WhoFor = () => {
  return (
    <section id="who-for" className="section-container">
      <div className="section-content">
        <div className="section-header">
          <h2 className="section-title">Who Is FindMeAgent For?</h2>
          <p className="section-description">
            Sellers, buyers, investors and relocating families all use FindMeAgent to compare vetted local agents
          </p>
        </div>

        <div className="who-for-grid">
          {whoIsItFor.map((item) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div key={item.id} className="who-for-card who-for-card-media" data-testid={`who-for-card-${item.id}`}>
                <div className="who-for-photo">
                  <img src={item.image} alt={item.imageAlt} loading="lazy" width="800" height="800" />
                  <div className="who-for-icon-wrapper who-for-icon-float">
                    <IconComponent className="who-for-icon" size={26} />
                  </div>
                </div>
                <div className="who-for-body">
                  <h3 className="who-for-title">{item.title}</h3>
                  <p className="who-for-description">{item.description}</p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="who-for-cta">
          <p className="who-for-cta-text">
            Whatever your move, start with a free shortlist of pre-vetted local experts
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhoFor;
